import React, { useMemo, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { SlidersHorizontalIcon } from 'lucide-react';
import { useStore } from '../contexts/StoreContext';
import { VehicleCard } from '../components/VehicleCard';
import { CatalogFilters } from '../components/catalog/CatalogFilters';
import { CatalogSyncNotice } from '../components/catalog/CatalogSyncNotice';
import { CatalogCover } from '../components/catalog/CatalogCover';
import { Modal } from '../components/ui/Modal';
import { CatalogFilters as Filters, filterVehicles, filtersFromParams, filtersToParams } from '../utils/catalog';
export function Catalog() {
  const {
    vehicles,
    brands
  } = useStore();
  const [params, setParams] = useSearchParams();
  const [drawer, setDrawer] = useState(false);
  const filters = filtersFromParams(params);
  const results = useMemo(() => filterVehicles(vehicles, brands, filters), [vehicles, brands, params]); // eslint-disable-line react-hooks/exhaustive-deps
  const onChange = (f: Filters) => setParams(filtersToParams(f), {
    replace: true
  });
  const activeCount = [filters.brand, filters.model, filters.segment, filters.body, filters.maxPrice, filters.maxMonthly, filters.maxDown, filters.term].filter(Boolean).length;
  const groups = useMemo(() => {
    if (filters.sort !== 'marca') return null;
    return brands.map(b => ({
      brand: b,
      items: results.filter(v => v.brandId === b.id)
    })).filter(g => g.items.length > 0);
  }, [results, brands, filters.sort]);
  return <div className="container-x py-8 lg:py-12" data-id="element-1192" data-mp="14rscwzu6e7eo">
      <CatalogCover count={results.length} data-id="element-1193" data-mp="zu0m6959orc2" />

      <div className="mt-6 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between" data-id="element-1194" data-mp="zv1z6j5ufnwf">
        <div data-id="element-1195" data-mp="vu06ymacgc3y">
          <CatalogSyncNotice data-id="element-1196" data-mp="vui19ddg4g98" />
        </div>
        <div className="flex gap-2" data-id="element-1197" data-mp="2u81j2oh9b49i">
          <button onClick={() => setDrawer(true)} className="btn btn-silver flex-1 lg:hidden" data-id="element-1198" data-mp="2u709ypjswruf">
            <SlidersHorizontalIcon className="h-4 w-4" aria-hidden data-id="element-1199" data-mp="2q817dbljl765" />
            Filtros{activeCount ? ` (${activeCount})` : ''}
          </button>
          <label htmlFor="sort" className="sr-only" data-id="element-1200" data-mp="sarceesumqmh">Ordenar</label>
          <select id="sort" className="input w-auto flex-1" value={filters.sort} onChange={e => onChange({
          ...filters,
          sort: e.target.value as Filters['sort']
        })} data-id="element-1201" data-mp="sccageedgrp3">
            <option value="marca" data-id="element-1202" data-mp="ik6j96vy2eay">Agrupar por marca</option>
            <option value="precio-asc" data-id="element-1203" data-mp="iilk13yoq76r">Menor precio</option>
            <option value="precio-desc" data-id="element-1204" data-mp="16bty2qfxlywv">Mayor precio</option>
          </select>
        </div>
      </div>

      <div className="mt-8 grid gap-8 lg:grid-cols-[260px_1fr]" data-id="element-1205" data-mp="1b93n44zes8k6">
        <aside className="hidden lg:block" aria-label="Filtros" data-id="element-1206" data-mp="xanh6g9dem33">
          <div className="sticky top-24 rounded-2xl border border-silver/40 bg-surface p-4 shadow-[0_0_18px_rgba(200,208,219,0.12)]" data-id="element-1207" data-mp="xc6vi1bgun28">
            <p className="mb-4 flex items-center gap-2 font-display text-lg font-black uppercase tracking-wider text-silver-hi" data-id="element-1208" data-mp="3hztn222eittw">
              <SlidersHorizontalIcon className="h-4 w-4" aria-hidden data-id="element-1209" data-mp="3n0r3a93updsr" />
              Filtrá
            </p>
            <CatalogFilters filters={filters} onChange={onChange} data-id="element-1210" data-mp="3egceu0gylz06" />
          </div>
        </aside>

        <div data-id="element-1211" data-mp="3aganol8uonz5">
          {results.length === 0 ? <div className="rounded-2xl border border-dashed border-line p-10 text-center" data-id="element-1212" data-mp="3ogv5pf6xyfrl">
              <h2 className="font-semibold" data-id="element-1213" data-mp="3jgqo1luarezs">No encontramos unidades con esos filtros</h2>
              <p className="mt-1 text-sm text-mist" data-id="element-1214" data-mp="2vrehktqctl16">Probá ampliar el presupuesto o quitar algún filtro. También podés pedir asesoramiento.</p>
              <div className="mt-5 flex flex-col justify-center gap-2 sm:flex-row" data-id="element-1215" data-mp="2qtw4qs97ulnw">
                <button onClick={() => onChange({
              ...filters,
              brand: '',
              model: '',
              segment: '',
              body: '',
              maxPrice: 0,
              maxMonthly: 0,
              maxDown: 0,
              term: 0
            })} className="btn btn-ghost" data-id="element-1216" data-mp="35hr2wo5zti8d">
                  Limpiar filtros
                </button>
                <Link to="/chequeo" className="btn btn-primary" data-id="element-1217" data-mp="2cz3h16j69z68">Hablar con un asesor</Link>
              </div>
            </div> : groups ? <div className="space-y-12" data-id="element-1218" data-mp="1bbhsmfofijcb">
              {groups.map(g => <section key={g.brand.id} aria-labelledby={`g-${g.brand.id}`} data-id="element-1219" data-mp="1g9jh5g4mjav6">
                  <div className="mb-4 flex items-baseline justify-between border-b border-line pb-3" data-id="element-1220" data-mp="1g7f9qo7intq5">
                    <h2 id={`g-${g.brand.id}`} className="font-display text-xl font-bold" data-id="element-1221" data-mp="1p23ca6lpixb9">{g.brand.name}</h2>
                    <Link to={`/marcas/${g.brand.slug}`} className="text-sm text-neon hover:text-neon-hi" data-id="element-1222" data-mp="1u1g7bemqfaox">Página de la marca</Link>
                  </div>
                  <div className="grid gap-5 sm:grid-cols-2 xl:grid-cols-3" data-id="element-1223" data-mp="1yypx4ve19oda">
                    {g.items.map(v => <VehicleCard key={v.id} vehicle={v} data-id="element-1224" data-mp="23xja8mperdcx" />)}
                  </div>
                </section>)}
            </div> : <div className="grid gap-5 sm:grid-cols-2 xl:grid-cols-3" data-id="element-1225" data-mp="9n5v699i3yed">
              {results.map(v => <VehicleCard key={v.id} vehicle={v} data-id="element-1226" data-mp="dp0uj87vg1pi" />)}
            </div>}
        </div>
      </div>

      <Modal open={drawer} onClose={() => setDrawer(false)} title="Filtrar catálogo" data-id="element-1227" data-mp="1cp1pzoay9xz">
        <CatalogFilters filters={filters} onChange={onChange} data-id="element-1228" data-mp="1avq05yu0zj4" />
        <button onClick={() => setDrawer(false)} className="btn btn-primary mt-3 w-full" data-id="element-1229" data-mp="3sjje2togj0ud">
          Ver {results.length} resultados
        </button>
      </Modal>
    </div>;
}